// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-profile-large{padding:0;max-width:672px}
`, "",{"version":3,"sources":["webpack://./src/app/components/ModalEditVisibilityInfosProfile/styles.scss"],"names":[],"mappings":"AAAA,qBACE,SAAU,CACV,eAAgB","sourcesContent":[".modal-profile-large {\n  padding: 0;\n  max-width: 672px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
